import React, { useEffect, useState } from "react";
import { useGlobalPopup } from "../../contexts/GlobalPopupContext";
import { useTranslation } from "../../contexts/TranslationContext";
import "./../../assets/css/profiles.scss";

const Profiles = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [editableFields, setEditableFields] = useState({
    Name: "",
    Email: "",
    Phone: "",
  });
  const { showPopup } = useGlobalPopup();
  const { language } = useTranslation();

  

  useEffect(() => {
    // Fetch user information from localStorage
    const userData = localStorage.getItem("FWUser");
    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        setUserInfo(parsedData.Information || parsedData);
        setEditableFields({
          Name: parsedData.Information?.Name || "",
          Email: parsedData.Information?.Email || "",
          Phone: parsedData.Information?.Phone || "",
        });
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const handleInputChange = (field, value) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    // Save updated fields to localStorage or send to API
    const updatedUserInfo = { ...userInfo, ...editableFields };
    setUserInfo(updatedUserInfo);
    localStorage.setItem("FWUser", JSON.stringify({ Information: updatedUserInfo }));
    showPopup({
      type: 'success',
      title: language.profiles?.profileUpdated || 'Profile Updated',
      content: language.profiles?.profileUpdatedSuccess || 'Profile updated successfully!',
      options: [{ text: language.profiles?.ok || 'OK', action: null, type: 'default' }],
      showCloseButton: true,
      backdrop: true
    });
  };

  if (!userInfo) {
    return <div className="loading">{language.profiles?.loading || 'Loading user information...'}</div>;
  }

  return (
    <div className="profileContainer">
      <h2>{language.profiles?.title || 'Profile Information'}</h2>
      <form className="profileDetails">
        
        <div className="profileField full-width">
          <label className="fieldLabel">{language.profiles?.name || 'Name'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={editableFields.Name}
            onChange={(e) => handleInputChange("Name", e.target.value)}
          />
        </div>
        <div className="profileField full-width">
          <label className="fieldLabel">{language.profiles?.address || 'Address'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.Address || language.common?.na || "N/A"}
            onChange={(e) => handleInputChange("Address", e.target.value)}
          />
        </div>
         <div className="profileField full-width">
          <label className="fieldLabel">{language.profiles?.agency || 'Agency'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.AgencyName || language.common?.na || "N/A"}
            readOnly
          />
        </div>
        <div className="profileField full-width">
          <label className="fieldLabel">{language.profiles?.agencyType || 'Agency Type'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.AgencyType || language.common?.na || "N/A"}
            readOnly
          />
        </div>
        <div className="profileField half-width">
          <label className="fieldLabel">{language.profiles?.createdDateTime || 'Created Date Time'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.CreatedTimeValue || language.common?.na || "N/A"}
            readOnly
          />
        </div>
        <div className="profileField half-width">
          <label className="fieldLabel">{language.profiles?.updateDateTime || 'Update Date Time'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.UpdatedTimeValue || language.common?.na || "N/A"}
            readOnly
          />
        </div>
        <div className="profileField half-width">
          <label className="fieldLabel">{language.profiles?.email || 'Email'}:</label>
          <input
            type="email"
            className="fieldValue"
            value={editableFields.Email}
            onChange={(e) => handleInputChange("Email", e.target.value)}
          />
        </div>
        
        <div className="profileField half-width">
          <label className="fieldLabel">{language.profiles?.phone || 'Phone'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={editableFields.Phone}
            onChange={(e) => handleInputChange("Phone", e.target.value)}
          />
        </div>
        <div className="profileField full-width">
          <label className="fieldLabel">{language.profiles?.userRole || 'User Role'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.UserRole || language.common?.na || "N/A"}
            readOnly
          />
        </div>
        <div className="profileField full-width">
          <label className="fieldLabel">{language.profiles?.status || 'Status'}:</label>
          <input
            type="text"
            className="fieldValue"
            value={userInfo.Status || language.common?.na || "N/A"}
            readOnly
          />
        </div>

        {/* <div className="profileActions">
          <button type="button" className="saveButton" onClick={handleSave}>
            {language.profiles?.saveChanges || 'Save Changes'}
          </button>
        </div> */}

      </form>
    </div>
  );
};

export default Profiles;